import { useQuery } from '@tanstack/react-query';
import { discoveryPool, discoverySignal } from '@/lib/appRelays';
import {
  BUSINESS_VERIFY_KIND,
  BUSINESS_VERIFY_GRANT_TAG,
  VERIFY_GRANT_ISSUERS,
  activeVerifiedPubkeys,
} from '@/lib/businessVerify';

/**
 * Fetch the list of business pubkeys that currently hold an active BCHNostr
 * verification grant (kind 30078, issued by a trusted issuer, non-revoked and
 * within its validity window).
 *
 * Only grants authored by VERIFY_GRANT_ISSUERS are trusted — enforced both at
 * the relay level (authors filter) and again in `parseVerificationGrant`.
 *
 * Returns a plain array (not a Set) so the result survives the persisted
 * localStorage query cache round-trip.
 */
export function useBchnostrVerified() {
  return useQuery({
    queryKey: ['nostr', 'bchnostr-verified'],
    queryFn: async (c) => {
      const events = await discoveryPool.query(
        [{
          kinds: [BUSINESS_VERIFY_KIND],
          authors: VERIFY_GRANT_ISSUERS,
          '#t': [BUSINESS_VERIFY_GRANT_TAG],
          limit: 1000,
        }],
        { signal: discoverySignal(c.signal) },
      );

      return [...activeVerifiedPubkeys(events)];
    },
    staleTime: 10 * 60 * 1000,
  });
}
